import tw from './tw';
import fb from './fb';
import ig from './ig';
import liin from './liin';

export default {
  tw,
  fb,
  ig,
  liin,
};
